import EnterprisesEmptyState from './EnterprisesEmptyState.component';

export default EnterprisesEmptyState;